import { BIKE_BONUS_PREMIUM } from '@vivaldis/web-ui'
import { Fragment, useCallback } from 'react'
import {
  LATE_SHIFT_BONUS_PREMIUM,
  MEAL_VOUCHERS_PREMIUM,
  MOBILITY_PREMIUM,
  MORNING_SHIFT_BONUS_PREMIUM,
  NIGHT_SHIFT_BONUS_PREMIUM,
  SOCIAL_KILOMETER_COMPENSATION_PREMIUM
} from '../../../../../../../Premiums'
import { Premium } from '../../../../../../typings/Premium'
import { useForm } from '../../../../providers/FormProvider'
import { LateShiftBonus } from './components/LateShiftBonus'
import { MealVouchers } from './components/MealVouchers'
import { MorningShiftBonus } from './components/MorningShiftBonus'
import { NightShiftBonus } from './components/NightShiftBonus'

// description is here: https://sealjobs.atlassian.net/wiki/spaces/SJ/pages/2079784991/Premies

interface Props {
  premiums: Premium[]
}

export const PremiumItems = ({ premiums }: Props) => {
  const { values } = useForm()

  const getPremiumComponentByPremiumId = useCallback(
    (premiumId: string, index: number) => {
      const premium = premiums.find(premium => premium.id === premiumId)

      switch (premium?.name) {
        case LATE_SHIFT_BONUS_PREMIUM:
          return <LateShiftBonus index={index} />
        case NIGHT_SHIFT_BONUS_PREMIUM:
          return <NightShiftBonus index={index} />
        case MORNING_SHIFT_BONUS_PREMIUM:
          return <MorningShiftBonus index={index} />
        case MEAL_VOUCHERS_PREMIUM:
          return <MealVouchers index={index} />
        case MOBILITY_PREMIUM:
          // NOTE: on position level we don't need field for this premium, because it doesn't have any value
          return null
        case BIKE_BONUS_PREMIUM:
          // NOTE: on position level this field should be empty (it's only required on contract level)
          return null
        case SOCIAL_KILOMETER_COMPENSATION_PREMIUM:
          // NOTE: on position level this field should be empty (it's only required on contract level)
          return null
        default:
          return <div>no inputs premium with type: "{premium?.name}"</div>
      }
    },
    [premiums]
  )

  return (
    <>
      {values.premiumValuesInput.map((premiumValueInput, index) => (
        <Fragment key={premiumValueInput.premiumId}>
          {getPremiumComponentByPremiumId(premiumValueInput.premiumId, index)}
        </Fragment>
      ))}
    </>
  )
}
